// https://www.kunkalabs.com/mixitup/docs/get-started/
// import mixitup from 'mixitup';
// import mixitupMultifilter from '../../../plugins/mixitup/dist/mixitup-multifilter.min.js';
// mixitup.use(mixitupMultifilter);

$(document).ready(function() {
    if ($('.mixit--filter').length) {
        // Init filters when browser back
        var firma = $('#filterFirma').val() ? $('#filterFirma').find('option:selected').data('firma') : false;
        if($('#filterGruppe').val()) {
          if($('#filterGruppe').val()) {
            var id = $('#filterGruppe').find('option:selected').data('id').toString();
            $('li.tag-control').each(function() {
              if($(this).data('gruppen').toString().split(',').includes(id) && (!firma || $(this).data('firmen').split(',').includes(firma))) {
                $(this).show();
              }
              else {
                $(this).hide();
              }
            });
          }
        }
        else {
          if(firma) {
            $('li.tag-control').each(function() {
              if($(this).data('firmen').split(',').includes(firma)) {
                $(this).show();
              }
              else {
                $(this).hide();
              }
            });
          }
        }
        var mixer = mixitup(".mixit--filter", {
            animation: {
                animateResizeTargets: true,
                duration: 550,
                nudge: true,
                reverseOut: false,
                effects: "fade scale(0.01) translateZ(-100px)"
            },
            selectors: {
                control: '.mixitup-control'
            },
            multifilter: {
                enable: true
            },
            load: {
              filter: ($('#filterGruppe').val() ? $('#filterGruppe').val()+($('#filterFirma').val() ? $('#filterFirma').val() : '') : ($('#filterFirma').val() ? $('#filterFirma').val() : null))
            },
            callbacks: {
              onMixEnd: function(state){
                if(state.hasFailed){
                   var noitems = 'Keine Angebote für Ihre Suchanfrage';
                   if($('#filterGruppe').val() && $('#filterFirma').val()) {
                     noitems = $('#filterFirma').find('option:selected').text()+' bietet keine Angebote der Kategorie '+$('#filterGruppe').find('option:selected').text()+'. <a id="resetGruppe" class="text-primary filter--text">Alle Kategorien von '+$('#filterFirma').find('option:selected').text()+' anzeigen</a>';
                   }
                   $('#noItems').html(noitems).show();
                   $('#resetGruppe').click(function() {
                     mixer.setFilterGroupSelectors('gruppe', ['']);
                     $('li.tag-control').removeClass('mixitup-control-active');
                     mixer.setFilterGroupSelectors('tag', ['']);
                     mixer.parseFilterGroups();
                     $('#filterGruppe').val('').trigger('change');
                   });
                }
                else{
                   $('#noItems').html('').hide();
                }
              }
            }
        });

        if($('li.tag-control').length && $('li.tag-control').length > 0) {
          mixer.setFilterGroupSelectors('tag', ['']);
        }
        mixer.setFilterGroupSelectors('gruppe', [$('#filterGruppe').val()]);
        if($('#filterFirma') && $('#filterFirma').length) {
          mixer.setFilterGroupSelectors('category', [$('#filterFirma').val()]);
        }
        //mixer.parseFilterGroups();
    }
    $('#filterGruppe').change(function() {
      $('#allTags').trigger('click');
      var firma = $('#filterFirma').val() ? $('#filterFirma').find('option:selected').data('firma') : false;
      if($(this).val()) {
        var id = $(this).find('option:selected').data('id').toString();
        $('li.tag-control').each(function() {
          if($(this).data('gruppen').toString().split(',').includes(id) && (!firma || $(this).data('firmen').split(',').includes(firma))) {
            $(this).show();
          }
          else {
            $(this).hide();
          }
        });
      }
      else {
        if(firma) {
          $('li.tag-control').each(function() {
            if($(this).data('firmen').split(',').includes(firma)) {
              $(this).show();
            }
            else {
              $(this).hide();
            }
          });
        }
        else {
          $('li.tag-control').show();
        }
      }
    });
    $('#filterFirma').change(function() {
      $('#allTags').trigger('click');
      var gruppe = $('#filterGruppe').val() ? $('#filterGruppe').find('option:selected').data('id').toString() : false;
      if($(this).val()) {
        var firma = $(this).find('option:selected').data('firma');
        $('li.tag-control').each(function() {
          if($(this).data('firmen').split(',').includes(firma) && (!gruppe || $(this).data('gruppen').toString().split(',').includes(gruppe))) {
            $(this).show();
          }
          else {
            $(this).hide();
          }
        });
      }
      else {
        if(gruppe) {
          $('li.tag-control').each(function() {
            if($(this).data('gruppen').toString().split(',').includes(gruppe)) {
              $(this).show();
            }
            else {
              $(this).hide();
            }
          });
        }
        else {
          $('li.tag-control').show();
        }
      }
    });


    //simple filter
    if ($('.mixit--filter--simple').length) {
        var mixer_simple = mixitup(".mixit--filter--simple", {
            animation: {
                animateResizeTargets: true,
                duration: 550,
                nudge: true,
                reverseOut: false,
                effects: "fade scale(0.01) translateZ(-100px)"
            },
            selectors: {
                control: '.mixitup-control'
            },
        });
    }


});

// $('.plus--keywords').click(function(){
//     // $('.keywords--wrap').toggleClass('show');
//     $(this).toggleClass('rotate');
//
//     // $(".keywords--wrap").animate({
//     //  height: "auto",
//     //   }, 1500 );
// })


$(function() {
    var nav = $('.keywords--wrap'),
        animateTime = 500,
        navLink = $('.plus--keywords');
    navLink.click(function() {
        if (nav.height() === 30) {
            autoHeightAnimate(nav, animateTime);
            $(this).addClass('rotate');
        } else {
            nav.stop().animate({
                height: '30px'
            }, animateTime);
            $(this).removeClass('rotate');
        }
    });
})

/* Function to animate height: auto */
function autoHeightAnimate(element, time) {
    var curHeight = element.height(), // Get Default Height
        autoHeight = element.css('height', 'auto').height(); // Get Auto Height
    element.height(curHeight); // Reset to Default Height
    element.stop().animate({
        height: autoHeight
    }, time); // Animate to Auto Height
}
